import CONFIG from "../config/config";
import { apiFetch } from "./http";

/**
 * notificationPrefs.api.js — client for the portal's notification preferences.
 *
 * Backend contract (controller/portalNotificationPrefs.controller.js), gated by
 * verifyPortalToken, v1-only (404s for a legacy portalusers session — see the
 * controller's requireV1User):
 *   GET /api/portal/notification-prefs -> { pushEnabled, robotStatus, advertisements, deliveryUpdates, accountAlerts }
 *   PUT /api/portal/notification-prefs -> same shape, updated
 *
 * Same source of truth as the mobile app (both write UserV1.notificationPrefs),
 * so toggling a category here reflects on mobile and vice versa the next time
 * either reads it.
 */

const BASE_URL = `${CONFIG.BASE_URL}/api/portal/notification-prefs`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("portalToken")}`,
});

export const DEFAULT_NOTIFICATION_PREFS = {
  pushEnabled: true,
  robotStatus: true,
  advertisements: true,
  deliveryUpdates: true,
  accountAlerts: true,
};

export const getNotificationPrefs = async () => {
  const res = await apiFetch(BASE_URL, { headers: authHeaders() });
  if (!res.ok) throw new Error("Failed to fetch notification preferences");
  return res.json();
};

export const updateNotificationPrefs = async (partial) => {
  const res = await apiFetch(BASE_URL, {
    method: "PUT",
    headers: { ...authHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify(partial),
  });
  if (!res.ok) throw new Error("Failed to update notification preferences");
  return res.json();
};
